'use strict';

var _ = require('lodash');

/**
 * Post Departure Mode: Flight Analysis - Cabin tab - Grid
 */
var FlightCabinGridPostDepartureTransformerFactory = function FlightCabinGridPostDepartureTransformerFactory(DataTransformer, momentService, metricReferenceDataService) {
  function FlightCabinGridPostDepartureTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'cabin-post-departure';
    this.targetType = 'cabin-flight-analysis-post-departure';
    this.priority = 1;
  }
  FlightCabinGridPostDepartureTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightCabinGridPostDepartureTransformer.constructor = FlightCabinGridPostDepartureTransformer;
  FlightCabinGridPostDepartureTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  FlightCabinGridPostDepartureTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightCabinGridPostDepartureTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  FlightCabinGridPostDepartureTransformer.prototype.transform = function (data) {
    var memorizedMomentOfDepartureTime = _.memoize(getMomentOfTime);
    var memorizedMomentOfArrivalTime = _.memoize(getMomentOfTime);
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var legCabins = data.domain.legCabins || data.domain.results;
    var result = [];
    for (var i = 0, length = legCabins.length; i < length; i++) {
      var entry = legCabins[i];
      var flightDepartureDateMoment = memorizedMomentOfDepartureDate(entry.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      var legDepartureDateMoment = memorizedMomentOfDepartureDate(entry.legDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      var momentDepartureDateTime = memorizedMomentOfDepartureTime(entry.departureTime, momentService.FIELD.DEPARTURE_TIME, memorizedMomentOfDepartureDate);
      var momentArrivalTime = memorizedMomentOfArrivalTime(entry.arrivalTime, momentService.FIELD.ARRIVAL_TIME, memorizedMomentOfDepartureDate);
      var newEntry = {
        operatingCarrier: entry.operatingCarrier,
        flightId: entry.flightId,
        entity: entry.entity,
        legId: entry.legId,
        carrier: entry.carrier,
        allotment: entry.allotment,
        arrivalTime: momentArrivalTime,
        bidPrice: entry.bidPrice,
        cabinIndex: entry.cabinIndex,
        sequence: entry.sequence,
        cabinCode: entry.cabinCode,
        daysToDeparture: entry.daysToDeparture,
        departureDateTimeMoment: momentDepartureDateTime,
        equipment: entry.equipment,
        aircraftConfig: entry.aircraftConfig,
        // value is in milliseconds
        flightDepartureDate: flightDepartureDateMoment.valueOf(),
        flightDepartureDateMoment: flightDepartureDateMoment,
        legDepartureDateMoment: legDepartureDateMoment,
        flightNumber: entry.flightNumber,
        opsSuffix: entry.opsSuffix,
        leg: entry.leg,
        legCabinId: entry.legCabinId,
        legDistance: entry.legDistance,
        physicalCapacity: entry.physicalCapacity,
        season: entry.season,
        dowGroup: entry.dowGroup,
        seatsAvailableModel: entry.seatsAvailableModel,
        groupMaterializationRate: entry.groupMaterializationRate,
        departureDateDOW: entry.departureDateDOW.substr(0, 3),
        //post departure

        resHoldTotalDeparture: entry.resHoldTotalDeparture,
        noShow: entry.noShow,
        groupNoShow: entry.groupNoShow,
        deniedBoarding: entry.deniedBoarding,
        upgradeInto: entry.upgradeInto,
        upgradeOut: entry.upgradeOut,
        downgradeInto: entry.downgradeInto,
        downgradeOut: entry.downgradeOut,
        misConnect: entry.misConnect,
        standByTotal: entry.standByTotal,
        standByTotalAggregate: entry.standByTotalAggregate,
        standByNotBoarded: entry.standByNotBoarded,
        trafficTotal: entry.trafficTotal,
        totalBoarding: entry.totalBoarding,
        ignorePostDepartureDataStatus: entry.ignorePostDepartureDataStatus || 'Include'
      };
      var metricValues = metricReferenceDataService.getMetricsDataForGrid(entry, ['postDepartureMetrics']);
      var entryWithMetrics = _.extend(newEntry, metricValues);
      result.push(entryWithMetrics);
    }
    return result;
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getMomentOfTime(date, field, memorizedMomentOfDate) {
    return memorizedMomentOfDate(date, field, 'HHmm');
  }
  return FlightCabinGridPostDepartureTransformer;
};
FlightCabinGridPostDepartureTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'MetricReferenceDataService'];
module.exports = FlightCabinGridPostDepartureTransformerFactory;